import React, { Component, Fragment } from 'react';
import { Carousel, Flex, Toast, PullToRefresh, Modal, Icon } from 'antd-mobile';
import { PriceText, CardOpenTip } from 'widget';
import _ from 'lodash';
import { ImgWrap } from 'pubBiz';
import util from 'utils';
import Config from 'config/Config';
import { observer, inject } from 'mobx-react';
import cx from 'classnames';
import './RedEnvelopeRainLess.less';
import CountDown from './RainCountDownView';
// import CountDown from 'pubBiz/CountDown';
import { number } from 'prop-types';
import activeAdPopupMod from 'pubBiz/ActiveAdPopup/indexMod';
import { toJS } from 'mobx';

const CDN_BASE = Config.CDN_BASE || '';
const redEnvelopeImg = [
  `${CDN_BASE}/assets/imgs/hongbao/hongbao.png`,
  `${CDN_BASE}/assets/imgs/hongbao/hongbao_click.png`,
  `${CDN_BASE}/assets/imgs/hongbao/hongbao_empty.png`
];

@inject('AppMod')
@inject('ShopHomeMod')
@observer
export default class RedEnvelopeRain extends Component {
  // class RedEnvelopeRain extends Component {
  constructor(props) {
    super(props);
    console.log('我是弹窗传参===', toJS(this.props.baseData));
    let startId = '',
      countId = '',
      startSaveId = '',
      countSaveId = '',
      showStartModal = false,
      showCountdownModal = false,
      countdownTime = 0,
      countTime = 0,
      startSecond = 0,
      redEnvelopeList = [],
      comeSpeed = 0.5, //间隔时间
      downSpeed = 3, //下落总时间
      startPopUpBackgroundImage = '',
      CountPopUpBackgroundImage = '';
    const startTime = util.getLocalCache('redEnvelopeStartTime');
    const startTimeOne = util.getLocalCache('redEnvelopeStartTimeOne');
    const nowTime = new Date().getTime();
    if (startTime > nowTime || startTimeOne > nowTime) {
      let _time = startTime;
      if (startTime > startTimeOne || startTimeOne > nowTime) {
        _time = startTimeOne;
      }
      countdownTime = (_time - nowTime) / 1000;
    }
    const baseData = toJS(this.props.baseData) || [];
    if (!this.props.needTimer) {
      baseData.map((el) => {
        if (el.popupRemindType == 4) {
          startId = el.id;
          startSaveId = el.saveId;
          showStartModal = true;
          startPopUpBackgroundImage = el.promptImgUrl;
          if (el.redPacketNum) {
            for (let index = 0; index < el.redPacketNum; index++) {
              const item = {
                clickIndex: 1,
                check: false,
                left: Math.floor(Math.random() * 550 + 50),
                transform: `rotate(${Math.floor(Math.random() * 90 - 45)}deg)`
              };
              redEnvelopeList.push(item);
            }
          }
          if (el.downSpeed) {
            downSpeed = el.downSpeed - 0;
          }
          if (el.comeSpeed) {
            comeSpeed = el.comeSpeed - 0;
          }
          console.log('======redEnvelopeList====', downSpeed, comeSpeed, redEnvelopeList);
        }
        if (el.popupRemindType == 5) {
          countId = el.id;
          countSaveId = el.saveId;
          const startTime = new Date(el.effectiveTime).getTime();
          showCountdownModal = true;
          startSecond = el.startSecond;
          countTime = startTime - nowTime;
          countdownTime = countTime / 1000;
          CountPopUpBackgroundImage = el.promptImgUrl;
        }
      });
    }

    this.state = {
      startId: startId,
      countId: countId,
      startSaveId: startSaveId,
      countSaveId: countSaveId,
      startPopUpBackgroundImage: startPopUpBackgroundImage,
      CountPopUpBackgroundImage: CountPopUpBackgroundImage,
      showStartModal: showStartModal,
      showCountdownModal: showCountdownModal,
      showRedEnvelopeModal: false,
      rainDown: false,
      startSecond: startSecond,
      countTime: countTime,
      countdownTime: countdownTime,
      redEnvelopeList: redEnvelopeList,
      downSpeed: downSpeed,
      comeSpeed: comeSpeed
    };
    this.clearTimeMethod = null;
    this.appStore = this.props.AppMod;
    this.ShoppingCartMod = this.props.ShoppingCartMod;
  }

  componentDidMount() {
    const { countdownTime } = this.state;
    let _countdownTime = countdownTime;
    if (_countdownTime > 0) {
      const timer = setInterval(() => {
        if (_countdownTime < 0) {
          clearInterval(this.clearTimeMethod);
          window.location.reload();
        }
        _countdownTime--;
        console.log(' 我是定时器啊===', _countdownTime);
      }, 1000);
      this.setState({
        countdownTime: _countdownTime
      });
      this.clearTimeMethod = timer;
    }
  }
  componentWillUnmount() {
    clearInterval(this.clearTimeMethod);
  }

  // 弹窗----开始了
  startModal = () => {
    const {
      redEnvelopeList,
      startId,
      startSaveId,
      startPopUpBackgroundImage,
      comeSpeed,
      downSpeed
    } = this.state;
    return (
      <Flex
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 9999
        }}
        direction="column"
        align="center"
        justify="center">
        <div className="red-share-app-modal">
          <div
            className="red_bag_content"
            style={{
              backgroundImage: `url('${startPopUpBackgroundImage}')`
            }}>
            {/* <span className='start_tips'>开始了</span> */}
            <Flex className="start_button_out">
              <div
                className="start_button"
                onClick={() => {
                  this.props.ShopHomeMod.hongbaoyuStart(startId).then((result) => {
                    if (result.data) {
                      if (result.data.redPacketNum) {
                        this.setState({
                          showStartModal: false,
                          rainDown: true,
                          startPopUpBackgroundImage: ''
                        });
                        const clickTime =
                          (redEnvelopeList.length * comeSpeed + downSpeed - comeSpeed) * 1000;
                        const endTime =
                          (redEnvelopeList.length * comeSpeed + downSpeed - comeSpeed + 1) * 1000;
                        const click_time = setTimeout(() => {
                          click_time && clearTimeout(click_time);
                          let getList = [];
                          this.props.ShopHomeMod.drawList(startId).then((el) => {
                            if (el) {
                              getList = el.list;
                              this.setState({ getList: getList });
                            }
                          });
                        }, clickTime);
                        const time = setTimeout(() => {
                          time && clearTimeout(time);
                          console.log('this.state.redEnvelopeList===>', this.state.getList);
                          this.setState({ rainDown: false, showRedEnvelopeModal: true });
                        }, endTime);
                      } else {
                        this.setState({ showStartModal: false, startPopUpBackgroundImage: '' });
                      }
                    } else {
                      Toast.info(result && result.resultMsg);
                      this.setState({ showStartModal: false, startPopUpBackgroundImage: '' });
                    }
                  });
                }}>
                开始
              </div>
            </Flex>
          </div>
          <span
            className="iconfont icon-close2"
            onClick={() => {
              this.setState({ showStartModal: false, startPopUpBackgroundImage: '' });
              this.props.ShopHomeMod.savePopupRecord(startSaveId);
            }}
          />
        </div>
      </Flex>
    );
  };

  // 弹窗----倒计时
  countdownModal = () => {
    const { startSecond, countId, countSaveId, countTime, CountPopUpBackgroundImage } = this.state;
    return (
      <Flex
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 9999
        }}
        direction="column"
        align="center"
        justify="center">
        <div className="red-share-app-modal">
          <div
            className="red_bag_content"
            style={{
              backgroundImage: `url('${CountPopUpBackgroundImage}')`
            }}>
            {/* <span className='start_tips'>红包倒计时</span> */}
            <Flex className="start_button_out" align="center" justify="center">
              {startSecond && startSecond > 0 && (
                <CountDown
                  className="count-down"
                  // time={(Number(countTime)) / 1000}
                  time={Number(startSecond)}
                  format={['', '', '', '']}
                  flag
                  onCountEnd={() => {
                    this.setState({ showCountdownModal: false });
                  }}
                />
              )}
            </Flex>
          </div>
          <span
            className="iconfont icon-close2"
            onClick={() => {
              this.setState({ showCountdownModal: false });
              this.props.ShopHomeMod.savePopupRecord(countSaveId);
            }}
          />
        </div>
      </Flex>
    );
  };

  // 弹窗----获得红包
  getRedEnvelopeModal = () => {
    const { getList = [] } = this.state;
    return (
      <Flex
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 9999
        }}
        direction="column"
        align="center"
        justify="center">
        {getList && !!getList.length ? (
          <div className="red-share-app-modal">
            <div className="get_background">
              <div className="goods_frame">
                <div className="goods_content">
                  {getList.map((el, index) => {
                    return (
                      <div className="goods_Item" key={index}>
                        <img
                          className="goods_img"
                          src={el.drawItemUrl || `${CDN_BASE}/assets/imgs/default2.png`}
                        />
                        <span className="goods_name">{el.awardName}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
              <Flex className="get_button_out">
                <div
                  className="get_button"
                  onClick={() => {
                    this.setState({ showRedEnvelopeModal: false });
                  }}>
                  开心收下
                </div>
                <span>获得优惠券,请到 我的-钱包-优惠券 中查看</span>
              </Flex>
            </div>
            <span
              className="iconfont icon-close2"
              onClick={() => {
                this.setState({ showRedEnvelopeModal: false });
              }}
            />
          </div>
        ) : (
          <div className="red-share-app-modal">
            <div className="get_background_nodata">
              <div className="goods_frame_nodata">
                <div className="goods_content_nodata">很遗憾您未抽到奖品</div>
              </div>
              <Flex className="get_button_out_nodata">
                <div
                  className="get_button"
                  onClick={() => {
                    this.setState({ showRedEnvelopeModal: false });
                  }}>
                  确认
                </div>
              </Flex>
            </div>
            <span
              className="iconfont icon-close2"
              onClick={() => {
                this.setState({ showRedEnvelopeModal: false });
              }}
            />
          </div>
        )}
      </Flex>
    );
  };

  // 下红包雨
  redEnvelopeRainDown = () => {
    const { redEnvelopeList, startId, comeSpeed, downSpeed } = this.state;
    return (
      <Flex
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 9999
        }}
        direction="column"
        align="center"
        justify="center">
        <div className="red-share-app-modal" id="red_envelope">
          {redEnvelopeList.map((el, index) => {
            return (
              <img
                className="red_envelope_img"
                style={{
                  left: el.left || index * 10 + 50,
                  animationDelay: `${index * comeSpeed + 1}s`,
                  transform: el.transform || `rotate(${index * 5 + 15}deg)`,
                  '--downSpeed': `redmove ${downSpeed}s linear`
                }}
                src={
                  !el.check
                    ? redEnvelopeImg[0]
                    : el.clickIndex == 1
                      ? redEnvelopeImg[1]
                      : redEnvelopeImg[2]
                }
                onClick={() => {
                  console.log('我被点了' + index);
                  el.check = true;
                  let _redEnvelopeList = this.state.redEnvelopeList;
                  _redEnvelopeList[index] = el;
                  this.setState({
                    redEnvelopeList: _redEnvelopeList
                  });
                  this.props.ShopHomeMod.drawStart(startId);
                }}
              />
            );
          })}
        </div>
      </Flex>
    );
  };

  render() {
    const { showStartModal, showCountdownModal, showRedEnvelopeModal, rainDown } = this.state;

    return (
      <div
        onClick={() => {
          // this.onXverse()
        }}>
        {showStartModal && this.startModal()}
        {showCountdownModal && this.countdownModal()}
        {showRedEnvelopeModal && this.getRedEnvelopeModal()}
        {rainDown && this.redEnvelopeRainDown()}
      </div>
    );
  }
}
// module.exports = RedEnvelopeRain;



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/components/RedEnvelopeRain/RedEnvelopeRainView.js